<template>
  <div class="gathercardApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
   
    <ul v-if="setGatherOrder.length > 0">
      <li v-for="(item,i) in setGatherOrder">
        <h2>{{item.title}}</h2>
        <p>单号：{{item.number}}</p>
        <p>激活卡号：{{item.card_id}}</p>
        <p>激活密码：{{item.card_pwd}}</p>
        <p v-if="item.user_id > 0">领取时间：{{item.bindtime}}</p>
        <p v-if="item.user_id > 0">领取手机：{{item.phone}}</p>
        <div class="expired" v-if="item.user_id > 0" style="color:green">已领取</div>
        <div class="expired" v-if="item.user_id <= 0">待领取</div>
      </li>
    </ul>
    <div class="none" v-if="setGatherOrder.length <= 0">暂无数据~</div>
  </div>
</template>

<script> 
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        userData:[],
        baseUrl:'',
        code:'',
        setGatherOrder:[]
      };
    },

    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        var id = this.$route.query.id;
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/gathercard?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }else{
        this.getGatherOrder();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getGatherOrder:function(){
        var that = this;
        that.fullscreenLoading = true;
        var id = this.$route.query.id;
        $.ajax({
          type:'post',
          url:that.$host+'home/gather/getCard',
          data:{
            user_id:that.userData.id,
            gather_id:id
          },
          dataType:'json',
          success:function(data){
            if(data.status == 200){
              that.setGatherOrder = data.data;
            }else{
              that.$alert(data.message,'提示');
            }
            that.fullscreenLoading = false;
          }
        })
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          that.getGatherOrder();
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .gathercardApp{
    max-width:640px;
    margin:0 auto;
    background:#ececec;
  }
  .gathercardApp .crumb{
    width:96%;
    margin:0 auto;
    padding:12px 0;
    font-size:15px;
    color:#1C222B
  }
  .gathercardApp .crumb a{
    float:right;
    color:#00A870;
    font-size:14px
  }
  .gathercardApp ul{
    width:96%;
    margin:0 auto;
    padding-top:12px
  }
  .gathercardApp ul li{
    background:#fff;
    margin-bottom:12px;
    border-radius:6px;
    padding:12px;
    position:relative;
  }
  .gathercardApp ul li h2{
    font-size:16px;
    color:#1C222B
  }
  .gathercardApp ul li p{
    font-size:14px;
    color:#3b3b3b;
    padding-top:6px
  }
  .gathercardApp ul li .expired{
    font-weight: bold;
    font-size: 14px;
    color: #E34D59;
    padding-top:6px
  }
  .gathercardApp .none{
    font-size:14px;
    color:#6b6b6b;
    text-align:center;
    padding-top:70%;
  }
  .gathercardApp .none a{
    color:#00A870;
    font-size:14px
  }
</style>